<template>
  <v-container class="fill-height pa-0" fluid>
    <v-row class="mt-auto mr-auto mb-0 justify-end">
      <v-col cols="12" sm="3" class="mb-0 pb-0"> </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredPrenotazioni"
      style="width: 100%"
      height="calc(100vh - 269px)"
      :items-per-page="15"
      :search="search"
      no-results-text="Nessun risultato"
      no-data-text="Nessun dato disponibile"
      fixed-header
      :footer-props="{
        'items-per-page-options': [15, 25, 50, -1],
        'items-per-page-text': 'Elementi per pagina',
        'items-per-page-all-text': 'Tutti',
      }"
      :loading="loading"
      show-select
      v-model="prenotazioniSelezionate"
      item-key="id_prenotazione"
      sort-by="data_ora_sort"
      :sort-desc="true"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-btn
            v-if="prenotazioniSelezionate.length != 0"
            color="primary"
            small
            depressed
            @click="prenotazioni_dialog_invio = true"
          >
            Invia
          </v-btn>
          <span
            v-if="prenotazioniSelezionate.length != 0"
            class="text-caption ml-2"
            >Prenotazioni selezionate:
            {{ prenotazioniSelezionate.length }}</span
          >
          <v-spacer></v-spacer>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filtroData"
                label="Entro il"
                append-icon="mdi-calendar"
                readonly
                color="primary"
                v-bind="attrs"
                v-on="on"
                style="max-width: 150px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filtroData"
              @input="menu = false"
              locale="it-IT"
              color="secondary"
              header-color="primary"
              first-day-of-week="1"
              show-adjacent-months
              @change="getPrenotazioni('', filtroData)"
            >
            </v-date-picker>
          </v-menu>
          <v-select
            label="Filtra per stato"
            v-model="filtro"
            :items="stati"
            item-value="id_stato"
            item-text="descrizione"
            hide-details
            class="mx-4"
            :clearable="true"
            style="max-width: 250px"
          ></v-select>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cerca"
            single-line
            hide-details
            :clearable="true"
            style="max-width: 250px"
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:[`item.data_ora_sort`]="{ item }">
        {{ formattedData(item.data_ora_sort, item.ora_fine) }}
      </template>

      <template v-slot:[`item.esportato`]="{ item }">
        <v-avatar
          :color="
            item.esportato == 0
              ? 'red'
              : item.esportato == 2
              ? 'green'
              : 'orange'
          "
          size="13"
        ></v-avatar>
      </template>
    </v-data-table>

    <!-- DIALOG INVIO -->
    <v-dialog v-model="prenotazioni_dialog_invio" max-width="500px" persistent>
      <v-card style="text-align: center">
        <v-card-title class="text-h5" style="justify-content: center"
          >Attenzione</v-card-title
        >
        <v-card-text class="pb-0">
          <span class="black--text text-subtitle-1">
            Sei sicuro di voler inviare
            {{ prenotazioniSelezionate.length }}
            {{
              prenotazioniSelezionate.length == 1
                ? "prenotazione"
                : "prenotazioni"
            }}?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="prenotazioni_dialog_invio = false"
          >
            Annulla
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="cambiaFlagEsportato()"
            :loading="prenotazioni_dialog_invio_loading"
            :disabled="prenotazioni_dialog_invio_loading"
          >
            Conferma
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
<script>
export default {
  data: () => ({
    search: "",
    loading: false,
    prenotazioni: [],
    prenotazioniSelezionate: [],
    prenotazioni_dialog_invio: false,
    prenotazioni_dialog_invio_loading: false,
    headers: [
      {
        text: "N. prenotazione",
        value: "id_prenotazione",
      },
      {
        text: "Ragione sociale cliente",
        value: "rag_soc_cliente",
      },
      {
        text: "Data e ora",
        value: "data_ora_sort",
      },
      {
        text: "Inviata",
        value: "esportato",
        align: "center",
      },
      {
        text: "Tipo scarico",
        value: "tipo_scarico",
      },
      {
        text: "Mittente",
        value: "mittente",
      },
      {
        text: "Vettore",
        value: "rag_soc_vettore",
      },
      {
        text: "Comparto",
        value: "category",
      },
      {
        text: "Bancali",
        value: "bancali",
      },
    ],
    menu: false,
    filtroData: "",
    stati: [
      {
        id_stato: 0,
        descrizione: "Non inviate",
      },
      {
        id_stato: 2,
        descrizione: "Inviate",
      },
    ],
    filtro: 0
  }),
  mounted() {
    this.$store.state.loaded = false;
    var today = new Date();
    var end = new Date(today);
    end.setDate(today.getDate() + 1);
    var format = (date) => date.toISOString().split("T")[0];
    this.filtroData = format(end);

    this.getPrenotazioni("", format(end));
  },
  computed: {
    filteredPrenotazioni() {
      if (this.filtro === 0 || this.filtro === 2) {
        return this.prenotazioni.filter((el) => {
          if (this.filtro == 2 && el.esportato == 2) {
            return true;
          } else if (this.filtro == 0 && (el.esportato == 0 || el.esportato == 1)) {
            return true;
          }
        });
      } else {
        return this.prenotazioni;
      }
    },
  },
  methods: {
    getPrenotazioni(start, end) {
      this.loading = true;

      var params = {
        da: start,
        a: end,
      };

      this.axios
        .get(
          `${this.$store.state.endpoint}/prenotazioni?${new URLSearchParams(
            params
          ).toString()}`
        )
        .then((response) => {
          this.prenotazioni = response.data.map((el) => {
            el["data_ora_sort"] = new Date(
              `${el["data"]}T${el["ora_inizio"]}`
            ).getTime();

            return el;
          });
          this.loading = false;
          this.$store.state.loaded = true;
        })
        .catch((e) => {
          this.$store.state.snackbar_text =
            "Non è stato possibile scaricare i dati relativi alle prenotazioni";

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          this.loading = false;
          this.$store.state.loaded = true;
          console.log("Errore prenotazioni", e);
        });
    },
    async cambiaFlagEsportato() {
      // Aggiorno lo stato di esportazione a "da esportare"
      try {
        this.prenotazioni_dialog_invio_loading = true;

        var res = await this.axios.put(
          `${this.$store.state.endpoint}/stato-esportazione`,
          {
            id_prenotazioni: this.prenotazioniSelezionate.map(
              (el) => el["id_prenotazione"]
            ),
            stato: 1,
            txt: "",
          }
        );

        var daInviare = this.prenotazioniSelezionate
          .filter((el) => res.data.includes(el.id_prenotazione))
          .map((el) => el.id_prenotazione);

        // Creo il file txt
        if (daInviare.length > 0) {
          await this.inviaPrenotazioni(daInviare);
        }

        this.$store.state.snackbar = true;
        this.$store.state.snackbar_text =
          this.prenotazioniSelezionate.length == 1
            ? "Prenotazione inviata con successo!"
            : "Prenotazioni inviate con successo!";
        this.$store.state.snackbar_color = "success";

        this.prenotazioniSelezionate = [];
        this.prenotazioni_dialog_invio = false;
      } catch (e) {
        this.gestisciErrorePrenotazioni(e);
      } finally {
        this.prenotazioni_dialog_invio_loading = false;

        var today = new Date();
        var start = new Date(today);
        start.setDate(today.getDate() - 30);
        var end = new Date(today);
        end.setDate(today.getDate() + 30);

        var format = (date) => date.toISOString().split("T")[0];

        this.getPrenotazioni(
          "",
          this.filtroData ? this.filtroData : format(end)
        );
      }
    },
    getTipoScaricoFromId(id) {
      if (
        this.$store.state.tipi_scarico &&
        this.$store.state.tipi_scarico.length != 0
      ) {
        return this.$store.state.tipi_scarico.filter(
          (el) => el["id_tipo_scarico"] == id
        )[0];
      }

      return null;
    },
    formattedData(data, oraFine) {
      const d = new Date(data);

      const giorno = String(d.getDate()).padStart(2, "0");
      const mese = String(d.getMonth() + 1).padStart(2, "0");
      const anno = d.getFullYear();

      const ore = String(d.getHours()).padStart(2, "0");
      const minuti = String(d.getMinutes()).padStart(2, "0");

      const oraInizio = `${ore}:${minuti}`;

      return `${giorno}/${mese}/${anno} ${oraInizio} - ${oraFine}`;
    },
    inviaPrenotazioni(prenotazioni) {
      return this.axios.post(
        `${this.$store.state.endpoint}/invio-prenotazioni`,
        {
          id_prenotazioni: prenotazioni,
        }
      );
    },
    gestisciErrorePrenotazioni(e) {
      this.$store.state.snackbar_text =
        this.prenotazioniSelezionate.length == 1
          ? "Non è stato possibile inviare la prenotazione"
          : "Non è stato possibile inviare le prenotazioni";

      if (
        e.response &&
        e.response.data &&
        e.response.data.message &&
        typeof e.response.data.message === "string"
      ) {
        this.$store.state.snackbar_text += ": " + e.response.data.message;
      } else {
        this.$store.state.snackbar_text +=
          ". Verifica la connessione internet o riprova più tardi";
      }

      this.$store.state.snackbar = true;
      this.$store.state.snackbar_color = "error";
      console.log("Errore invio prenotazioni", e);
    },
  },
};
</script>
